import { defineStore } from 'pinia';
import { io, Socket } from 'socket.io-client';

interface SocketState {
    socket?: Socket;     // the live instance
    isConnected: boolean;
}

export interface SocketMessage {
    Source: string;
    Target: string;
    Event: string;
    Data: any;
}

export const SOCKET_CHANNEL = 'StarTmsIO';

export const useSocketStore = defineStore('socket', {
    state: (): SocketState => ({
        socket: undefined,
        isConnected: false,
    }),

    actions: {
        /**
         * Initialize (or return existing) socket.
         * Call this once—preferably in main.ts after the app mounts.
         */
        init(apiUrl?: string) {
            // Already created? → just hand it back.
            if (this.socket) return this.socket;

            const url = apiUrl ?? window.location.origin;
            this.socket = io(url, {
                path: '/api/socket.io',
                transports: ['websocket', 'polling'],
            });

            // --- wiring standard events ---
            this.socket.on('connect', () => {
                this.isConnected = true;
                console.log('[socket] connected:', this.socket?.id);
            });

            this.socket.on('disconnect', (reason: string) => {
                this.isConnected = false;
                console.log('[socket] disconnected:', reason);
            });

            this.socket.on('connect_error', (error: Error) => {
                console.error('[socket] connect_error:', error);
            });

            this.socket.on('error', (error: Error) => {
                console.error('[socket] error:', error);
            });

            // --- custom channel handling ---
            this.socket.on(SOCKET_CHANNEL, (msg: SocketMessage) => {
                console.log(`📥 FE: Received on [${SOCKET_CHANNEL}]:`, msg);
            });

            // Subscribe to all channels
            // ['planner', 'loadboard', 'main', 'web'].forEach((channel) => {
            //     this.socket?.on(channel, (msg: SocketMessage) => {
            //         console.log(`📥 FE: Received on [${channel}]:`, msg);
            //     });
            // });

            return this.socket;
        },

        /**
         * Handy getter that guarantees the socket exists.
         */
        getInstance() {
            if (!this.socket) {
                throw new Error('Socket not initialize. Call useSocketStore().init() first.');
            }
            return this.socket;
        },
    },
});
